// Feature flags for the public shop.
// Set SHOW_CREDIT back to true to re-enable the "Equipos a Crédito" section,
// nav links, ribbon button and the "Solicitar crédito" buttons across the store.
export const SHOW_CREDIT = false;
